/**
 * 1WAY EXOTIC — Shopify Theme JavaScript
 * Cart drawer, header scroll, mobile menu, product page, toast
 */

document.addEventListener('DOMContentLoaded', function () {
  // === HEADER SCROLL ===
  const header = document.querySelector('[data-header]')
  if (header) {
    let ticking = false
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          header.classList.toggle('scrolled', window.scrollY > window.innerHeight * 0.7)
          ticking = false
        })
        ticking = true
      }
    })
  }

  // === MOBILE MENU ===
  const mobileToggle = document.querySelector('[data-mobile-toggle]')
  const mobileMenu = document.querySelector('[data-mobile-menu]')
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => mobileMenu.classList.toggle('active'))
  }

  // === CART DRAWER ===
  const cartToggle = document.querySelector('[data-cart-toggle]')
  const cartDrawer = document.querySelector('[data-cart-drawer]')
  const cartOverlay = document.querySelector('[data-cart-overlay]')
  const cartClose = document.querySelector('[data-cart-close]')
  const cartBody = document.querySelector('[data-cart-body]')

  function openCart () {
    cartDrawer.classList.add('active')
    cartOverlay.classList.add('active')
    document.body.style.overflow = 'hidden'
  }
  function closeCart () {
    cartDrawer.classList.remove('active')
    cartOverlay.classList.remove('active')
    document.body.style.overflow = ''
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart)
  if (cartClose) cartClose.addEventListener('click', closeCart)
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart)

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart()
  })

  // === ADD TO CART ===
  const toast = document.querySelector('[data-toast]')
  function showToast (message) {
    if (!toast) return
    const msgEl = toast.querySelector('.toast__message')
    if (msgEl) msgEl.textContent = message || 'Added to cart'
    toast.classList.add('active')
    setTimeout(() => toast.classList.remove('active'), 3000)
  }

  // Product form add to cart
  const productForm = document.getElementById('product-form')
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault()
      const formData = new FormData(productForm)
      const addBtn = productForm.querySelector('[data-add-to-cart]')
      const addText = productForm.querySelector('[data-add-text]')
      const addedText = productForm.querySelector('[data-added-text]')

      if (addBtn) addBtn.disabled = true

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(r => r.json())
        .then(() => {
          showToast('Added to cart')
          if (addText) addText.hidden = true
          if (addedText) addedText.hidden = false
          setTimeout(() => {
            if (addText) addText.hidden = false
            if (addedText) addedText.hidden = true
            if (addBtn) addBtn.disabled = false
          }, 2000)
          refreshCartDrawer()
          updateCartCount()
        })
        .catch(err => {
          console.error('Add to cart error:', err)
          if (addBtn) addBtn.disabled = false
        })
    })
  }

  // === PRODUCT PAGE: Variant Selection ===
  const variantInput = document.querySelector('input[name="id"]')
  const optionBtns = document.querySelectorAll('.product-main__option-btn')

  optionBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const optionName = this.dataset.option
      const value = this.dataset.value

      // Update active state
      document.querySelectorAll('.product-main__option-btn[data-option="' + optionName + '"]').forEach(function (b) {
        b.classList.remove('active')
      })
      this.classList.add('active')

      // Find matching variant
      if (variantInput) {
        const productForm = document.getElementById('product-form')
        if (productForm) {
          const selectedOptions = []
          document.querySelectorAll('.product-main__option-btn.active').forEach(function (activeBtn) {
            selectedOptions.push(activeBtn.dataset.value)
          })

          // Get variant from data
          const variantDataEl = document.querySelector('[data-variants]')
          if (variantDataEl) {
            try {
              const variants = JSON.parse(variantDataEl.dataset.variants)
              const matched = variants.find(function (v) {
                return selectedOptions.every(function (opt, i) { return v.options[i] === opt })
              })
              if (matched) {
                variantInput.value = matched.id
              }
            } catch (e) {}
          }
        }
      }
    })
  })

  // === PRODUCT PAGE: Quantity ===
  const qtyInput = document.getElementById('product-qty')
  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return
      const delta = parseInt(this.dataset.qty)
      const current = parseInt(qtyInput.value) || 1
      const newVal = Math.max(1, current + delta)
      qtyInput.value = newVal
    })
  })

  // === PRODUCT PAGE: Image Thumbnails ===
  const mainImage = document.getElementById('main-product-image')
  document.querySelectorAll('.product-main__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) mainImage.src = this.dataset.thumb
      document.querySelectorAll('.product-main__thumb').forEach(function (t) { t.classList.remove('active') })
      this.classList.add('active')
    })
  })

  // === CART: Update Quantity in Drawer ===
  document.addEventListener('click', function (e) {
    const updateBtn = e.target.closest('[data-update-qty]')
    if (updateBtn) {
      const key = updateBtn.dataset.updateQty
      const delta = parseInt(updateBtn.dataset.delta)

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [key]: delta } })
      })
        .then(r => r.json())
        .then(function () {
          refreshCartDrawer()
          updateCartCount()
        })
    }

    const removeBtn = e.target.closest('[data-remove-item]')
    if (removeBtn) {
      const key = removeBtn.dataset.removeItem
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [key]: 0 } })
      })
        .then(r => r.json())
        .then(function () {
          refreshCartDrawer()
          updateCartCount()
        })
    }
  })

  // === UPDATE CART COUNT ===
  function updateCartCount () {
    fetch('/cart.js')
      .then(r => r.json())
      .then(function (cart) {
        const countEl = document.querySelector('[data-cart-count]')
        if (countEl) countEl.textContent = cart.item_count
      })
  }

  // === REFRESH CART DRAWER ===
  function refreshCartDrawer () {
    fetch('/cart')
      .then(r => r.text())
      .then(function () {
        // Simple refresh - in production, you'd update the DOM inline
        // For now, reload the page to reflect cart changes
        // window.location.reload()
        updateCartCount()
      })
  }

  // === ANNOUNCEMENT BAR DISMISS ===
  const announcementClose = document.querySelector('[data-announcement-close]')
  const announcement = document.querySelector('[data-announcement]')
  if (announcementClose && announcement) {
    announcementClose.addEventListener('click', function () {
      announcement.style.display = 'none'
      localStorage.setItem('1we-announcement-dismissed', 'true')
    })
    if (localStorage.getItem('1we-announcement-dismissed')) {
      announcement.style.display = 'none'
    }
  }

  // === PHONE INPUT FORMATTING ===
  const phoneInput = document.querySelector('input[type="tel"]')
  if (phoneInput) {
    phoneInput.addEventListener('input', function (e) {
      let value = e.target.value.replace(/\D/g, '').slice(0, 10)
      if (value.length <= 3) { e.target.value = value } else if (value.length <= 6) { e.target.value = '(' + value.slice(0, 3) + ') ' + value.slice(3) } else { e.target.value = '(' + value.slice(0, 3) + ') ' + value.slice(3, 6) + '-' + value.slice(6) }
    })
  }
})
